import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import { enUSUi, enUSSkill, enUSSkillLog, enUSHomeIndex } from '@refly/i18n/en-US';
import { zhHansUi, zhHansSkill, zhHansSkillLog, zhHansHomeIndex } from '@refly/i18n/zh-Hans';

// 同步初始化 i18next。资源来自内存对象，init 会同步完成，
// 因此只要在任何组件渲染前 import 本模块，useTranslation 拿到的就是已就绪的实例，
// 不会出现 NO_I18NEXT_INSTANCE / 直接显示翻译 key 的问题。
// 使用幂等保护，避免 React 18 dev 下 effect 重复执行导致 "already initialized" 告警与重复 init。
const initI18n = () => {
  if (i18next.isInitialized) {
    return i18next;
  }

  i18next
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
      debug: process.env.NODE_ENV === 'development',
      defaultNS: 'ui',
      fallbackLng: 'en',
      // 浏览器可能返回 zh-Hans / zh-Hans-CN / en-US 等带地区码的语言，
      // 只取主语言以命中 en / zh 资源，避免匹配不到时直接显示翻译 key。
      load: 'languageOnly',
      nonExplicitSupportedLngs: true,
      supportedLngs: ['en', 'zh', 'zh-CN'],
      // 内存资源，同步 init，无需异步加载
      initImmediate: false,
      resources: {
        en: {
          ui: enUSUi,
          skill: enUSSkill,
          skillLog: enUSSkillLog,
          homeIndex: enUSHomeIndex,
        },
        'zh-CN': {
          ui: zhHansUi,
          skill: zhHansSkill,
          skillLog: zhHansSkillLog,
          homeIndex: zhHansHomeIndex,
        },
        zh: {
          ui: zhHansUi,
          skill: zhHansSkill,
          skillLog: zhHansSkillLog,
          homeIndex: zhHansHomeIndex,
        },
      },
    });

  return i18next;
};

// 模块加载即同步初始化，确保任何 useTranslation 之前实例已就绪。
initI18n();

// 导出已初始化的实例。配合 rsbuild alias 将 react-i18next / i18next 强制解析到单一
// 物理副本，可跨懒加载 chunk 可靠命中同一实例，避免 NO_I18NEXT_INSTANCE。
export const i18n = i18next;

// 保留 setupI18n 供入口在挂载 React 树前调用，幂等，不会重复 init。
export const setupI18n = () => {
  return initI18n();
};
